import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityArrayResponseType } from './cut-off.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { TableOptions } from './i-bary-table-fetch-service';
import { Observable } from 'rxjs';
import { createRequestOption } from '../app/shared/util/request-util';
import { ApiProviderService } from './api-provider.service';
import { ICutOff } from '../models/cut-off.model';
import { BaryCutOffService } from './bary-cutoff.service';

@Injectable({ providedIn: 'root' })
export class BaryCutoffExtendedService extends BaryCutOffService {
  protected endPoint = API_ENDPOINTS.CUT_OFFS;

  constructor(protected apiProvider: ApiProviderService, protected override http: HttpClient) {
    super(http);
  }

  override query(req?: any, tableOption?: TableOptions): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    if (tableOption?.appendPath) {
      return this.apiProvider.publicGet<ICutOff[]>(this.endPoint + tableOption.appendPath, {
        params: options,
        observe: 'response',
      });
    }
    return this.apiProvider.publicGet<ICutOff[]>(this.endPoint, { params: options, observe: 'response' });
  }
}
